import React, { useMemo, useCallback } from 'react';
import FullWidthModal from '../common/Modal/FullWidthModal';
import ModalHeader from '../common/ModalHeader/index';
import cn from 'classnames';
import styles from './loyaltyCopy.module.scss';
import { TouchableButton } from '../common/Touchable/index';
import { LABEL } from '../../veriables';
import Loader from '../common/Loader/newLoaderModal';
import { connect } from "react-redux";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const ViewloyaltyOffers = (props) => {
  const {
    newOfferPopUp,
    serverAppTheme,
    seat,
    handleDoneBtnClick,
    loading,
    orderingPortraitOrientation,
    seatData,
  } = props;

  const seatMap = useMemo(() => {
    const map = new Map();

    seatData?.seats?.forEach((s) => {
      const key = `${s?.loyalty?.id}_${s?.loyalty?.seatId}`;
      map.set(key, s?.number);
    });

    return map;
  }, [seatData]);

  const offersList = useMemo(() => {
    return (
      seat?.loyalties?.flatMap((loyalty) =>
        (loyalty?.offers || []).map((offer) => {
          const key = `${loyalty?.checkLoyaltyId}_${loyalty?.seatId}`;

          return {
            offerId: offer?.offerId,
            offerName: offer?.name,
            value: offer?.value || 0,
            seatNumber: seatMap.get(key),
            guestName: loyalty?.guestName,
            accountNumber: loyalty?.displayAccountNumber,
            uniqueKey: `${offer?.offerId}_${key}`,
          };
        })
      ) || []
    );
  }, [seat?.loyalties, seatMap]);


  const handleDoneClick = useCallback((event) => {
    event.preventDefault();
    handleDoneBtnClick();
  }, [handleDoneBtnClick]);

  return (
    <FullWidthModal
      isOpen={newOfferPopUp}
      customClass2={cn('w-100 h-100 position-relative')}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        border: '0',
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      {loading && <Loader />}

      <div className="col-12 px-0 text-center h-100">
        <div className="col-12 px-0 fs_18 h-100">
          
          <ModalHeader
            stationName={seatData?.stationName}
            tileHeader="Available Offers"
            seatNumber={seatData?.number}
            customHeight={'35px'}
          />

          {/* Header Row */}
          <div
            className={cn(
              'px-2 pt-2 d-flex align-items-center fw-normal mx-2',
              orderingPortraitOrientation ? 'fs_12' : 'fs_14'
            )}
            style={{
              fontFamily: 'Poppins',
              color: serverAppTheme?.secondary_text,
            }}
          >
            <div className="col-4 text-left">Offer</div>
            <div className="col-1 text-left">Value</div>
            <div className="col-1 text-left">Seat</div>
            <div className="col-3 text-left">Guest Name</div>
            <div className="col-3 text-left">Account Number</div>
          </div>

          {/* Offer List */}
          <div className={cn('overflowY', orderingPortraitOrientation ? 'h-77 px-2 pt-2' : 'h-76')}>
            {offersList.length > 0 ? (
              offersList.map((offer) => (
                <div
                  key={offer.uniqueKey}
                  className={cn(
                    styles.offerTile,
                    'p-2 d-flex align-items-center mb-2 rounded',
                    orderingPortraitOrientation ? 'fs_12' : 'fs-16'
                  )}
                  style={{
                    background: serverAppTheme?.checkDetail_tabs,
                    border: serverAppTheme?.select_border,
                  }}
                >
                  <div className="col-4 text-left">{offer.offerName}</div>

                  <div className="col-1 text-left">
                    {LABEL().CURRENCY_SYMBOL}
                    {(offer?.value || 0)?.toFixed(2)}
                  </div>

                  <div className="col-1 text-left">
                    <div
                      className="fw-500 roundedSm d-flex justify-content-center align-items-center"
                      style={{
                        width: '1.8rem',
                        height: '1.25rem',
                        background: serverAppTheme?.seat_bg,
                        color: serverAppTheme?.seat_box_text,
                      }}
                    >
                      {offer.seatNumber}
                    </div>
                  </div>

                  <div className="col-3 text-left">{offer.guestName}</div>
                  <div className="col-3 text-left">{FormatLoyaltyPhoneNumber(offer.accountNumber)}</div>
                </div>
              ))
            ) : (
              <div className="d-flex justify-content-center h-100 align-items-center fs_32 fw-600">
                {LABEL().OLLS_NO_OFFERS}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className={cn('pt-2 d-flex justify-content-center', orderingPortraitOrientation ? 'col-12 px-3' : '')}>
            <div className={cn('d-flex mb-12', orderingPortraitOrientation ? 'col-6' : 'col-4')}>
              <TouchableButton
                type="button"
                className={cn(
                  'col-12 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color',
                  styles.loyalty_btn
                )}
                style={{ height: '7.5vh' }}
                onClick={handleDoneClick}
                rippleEffect={true}
              >
                <div className={cn("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>
                  {LABEL().OLLS_DONE}
                </div>
              </TouchableButton>
            </div>
          </div>

        </div>
      </div>
    </FullWidthModal>
  );
};

const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
  seatData: orders.seats,
});

export default connect(mapStateToProps)(ViewloyaltyOffers);